const selectors = {
  toggleDrawer: '[data-toggle-pdp-size-guide]',
  sizeGuideDrawer: '[data-pdp-size-guide-drawer]',
  radioInputs: 'input[name="size-guide-unit"]',
  sizeGuideTable: '.size-guide__table',
  sizeGuideToolTip: '.size-guide__tooltip',
  showMoreModels: '.size-guide__models-show-more',
  models: '.size-guide__model',
  sizeChartTrigger: '.size-chart a',
  sizeGuideModal: '.size-guide',
  popupClose: '.popup-close',
};

const classes = {
  active: 'size-guide--active',
  toolTipHidden: 'size-guide__tooltip--hidden',
  modelActive: 'size-guide__model--active',
  modalVisible: 'size-guide--visible',
};

function pdpSizeGuide() {
  const toggleDrawerElements = document.querySelectorAll(selectors.toggleDrawer);
  const sizeGuideDrawer = document.querySelector(selectors.sizeGuideDrawer);

  if (toggleDrawerElements && sizeGuideDrawer) {
    initDrawerSizeGuide(toggleDrawerElements, sizeGuideDrawer);
  }

  initModalSizeGuide();
}

function initDrawerSizeGuide(toggleDrawerElements, sizeGuideDrawer) {
  const radioInputs = document.querySelectorAll(selectors.radioInputs);
  const sizeGuideTableWrapper = document.querySelector(selectors.sizeGuideTable);
  const sizeGuideTable = sizeGuideTableWrapper?.querySelector('table');
  const showMoreModels = sizeGuideDrawer?.querySelector(selectors.showMoreModels);
  const models = sizeGuideDrawer?.querySelectorAll(selectors.models);

  toggleDrawerElements.forEach((toggleElement) => {
    toggleElement.addEventListener('click', () => {
      sizeGuideDrawer.classList.toggle(classes.active);
    });
  });

  function appendToolTip() {
    const secondRowHeader = sizeGuideTable.querySelector('tr:nth-of-type(2) th');
    const toolTip = document.querySelector(selectors.sizeGuideToolTip);

    if (!secondRowHeader || !toolTip) return;
    secondRowHeader.appendChild(toolTip);

    toolTip.classList.remove(classes.toolTipHidden);
  }

  function updateTableUnits(unit) {
    const tableCells = document.querySelectorAll(`${selectors.sizeGuideTable} td`);

    tableCells.forEach((cell) => {
      const cellValue = cell.textContent;
      let values = cellValue.split('/').map(parseFloat);

      if (unit === 'INCH') {
        values = values.map((value) => Math.round((value / 2.54) * 2) / 2);
        cell.dataset.inches = values.join('/');
      }
    });

    sizeGuideTableWrapper.dataset.units = unit;
  }

  if (!radioInputs || !sizeGuideTable) return;

  function checkInitiallySelected() {
    const checkedInput = document.querySelector(`${selectors.radioInputs}:checked`);

    if (checkedInput) {
      updateTableUnits(checkedInput.value);
    }
  }

  checkInitiallySelected();
  appendToolTip();

  radioInputs.forEach(function (input) {
    input.addEventListener('change', function (event) {
      if (event.target.checked) {
        updateTableUnits(event.target.value);
      }
    });
  });

  if (!showMoreModels || !models) return;

  showMoreModels.addEventListener('click', () => {
    models.forEach((model, i) => {
      if (i < 1) return;
      model.classList.toggle(classes.modelActive);
      showMoreModels.style.display = 'none';
    });
  });
}

function initModalSizeGuide() {
  // Handle .size-chart a clicks (replaces jQuery functionality)
  document.addEventListener('click', (event) => {
    // Handle size chart trigger clicks
    if (event.target.matches(`${selectors.sizeChartTrigger}, ${selectors.sizeChartTrigger} *`)) {
      event.preventDefault();

      const sizeGuideElements = document.querySelectorAll(selectors.sizeGuideModal);
      sizeGuideElements.forEach((element) => {
        element.style.display = 'block';
        element.classList.add(classes.modalVisible);
        // Fade in effect
        element.style.opacity = '0';
        element.style.transition = 'opacity 0.3s ease';
        requestAnimationFrame(() => {
          element.style.opacity = '1';
        });
      });
    }

    // Handle popup close clicks
    if (event.target.matches(`${selectors.popupClose}, ${selectors.popupClose} *`)) {
      const sizeGuideElements = document.querySelectorAll(selectors.sizeGuideModal);
      sizeGuideElements.forEach((element) => {
        // Fade out effect
        element.style.transition = 'opacity 0.3s ease';
        element.style.opacity = '0';
        setTimeout(() => {
          element.style.display = 'none';
          element.classList.remove(classes.modalVisible);
        }, 300);
      });
    }
  });
}

export default pdpSizeGuide;
